import logUtil from 'utils/log'
import differenceInDaysDateUtil from 'utils/date/difference-in-days'
import isFullSizeVariantUtil from 'modules/variant/utils/is-full-size'

const MIN_DAYS_TO_SHOW_BANNER_AFTER_CLOSURE = 1

/**
 * @param props
 * @param props.currentVariant
 * @param props.closedAtStr
 * @param props.isFromGoogleProductListAd
 * @param props.isNewCustomer
 * @returns {boolean}
 */
const shouldShowYouVeUnlockedPercentageOffAtCheckoutBannerSelectUtil = (props) => {
  const {
    closedAtStr,
    currentVariant,
    isFromGoogleProductListAd,
    isNewCustomer
  } = props

  if (!isNewCustomer) {
    return false
  }

  logUtil('shouldShowYouVeUnlockedPercentageOffAtCheckoutBannerSelectUtil').debug('[start] props=', props)

  if (!isFromGoogleProductListAd) {
    logUtil('shouldShowYouVeUnlockedPercentageOffAtCheckoutBannerSelectUtil').debug('[noop] not from google PLA')
    return false
  }

  if (!isFullSizeVariantUtil(currentVariant)) {
    logUtil('shouldShowYouVeUnlockedPercentageOffAtCheckoutBannerSelectUtil').debug('[noop] not a full size')
    return false
  }

  if (!closedAtStr) {
    return true
  }

  const closedAt = new Date(closedAtStr)
  const daysDiff = differenceInDaysDateUtil(
    new Date(),
    new Date(closedAt)
  )

  return (
    daysDiff >= MIN_DAYS_TO_SHOW_BANNER_AFTER_CLOSURE
  )
}

export default shouldShowYouVeUnlockedPercentageOffAtCheckoutBannerSelectUtil
